import {
	createBrowserRouter,
	Navigate,
	RouterProvider,
} from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

import { Home } from './home/Home';
import { IssueView } from '../../views/issue/Issue';
import config from '../../config';

import './App.css';
import { useTrackingInstallion } from '../../tracking/Tracking.hooks';
import { useAuth } from '../../views/home/auth/Authentication.hooks';
import Drafts from '../../views/drafts/Drafts';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	useTrackingInstallion();
	const routes = [
		{
			path: '/',
			element: <Home />,
		},
		{
			path: '/issues/:id',
			element: <AuthIssue />,
		},
		{
			path: '/issues/:id/:articleId',
			element: <AuthIssue />,
		},
		{
			path: '*',
			element: <Navigate to="/" replace />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}

	const router = createBrowserRouter(routes, {
		basename,
	});

	const classNames = ['App'];
	if (config.app.contentProtection) {
		// classNames.push('content-protection');
	}

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

function AuthIssue() {
	useAuth({ redirect: true });
	return (
		<>
			<IssueView />
		</>
	);
}

export default App;
